export default {
  agree: '/v3/safe/promise/agree'
}
